module.exports = __webpack_public_path__ + "assets/Tau.524fa92bb9a6a02cb54233ec53fbcf54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Tau.png
// module id = 847
// module chunks = 0